import { useState, useEffect, useRef } from "react";
import "./Home.css";
import Product from "./Product";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProductDetail from "./ProductDetail";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { useStateValue } from "./StateProvider";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";
function Home() {
  let i = 0;
  const [{ basket }, dispatch] = useStateValue();
  const [products, setProducts] = useState([]);
  const mySectionRef = useRef(null); // section to scroll to for product description
  const { productId } = useParams(); // product that was clicked
  const { state } = useLocation();
  useEffect(() => {
    const dbRef = collection(db, "ProductTable");
    const q = query(dbRef, orderBy("createdAt", "asc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setProducts(
        querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      );
    });
    return unsubscribe;
  }, []);
  useEffect(() => {
    // GA tracking
    ReactGA.send({
      hitType: "pageview",
      page: "/Home",
      title: "Home page viewed",
    });
  }, []);
  // scroll to product description section
  useEffect(() => {
    if (productId) {
      if (mySectionRef.current) {
        mySectionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [productId]); //
  return (
    <Box className="home" sx={{ flexGrow: 1 }}>
      <Grid container spacing={1}>
        {state && (
          <Grid item xs={12} className="home__row" key={new Date()}>
            <Link
              to={`/Home/${state?.result.id}`}
              onClick={() => {
                //
                // keep a copy on device storage for retreival in Detail page, if detail page refreshes
                localStorage.setItem(
                  "dls-pedroDetail",
                  JSON.stringify({ ...state?.result })
                );
                //
                // dispatch to reducer
                dispatch({
                  type: "SELECT_ITEM",
                  item: {
                    sellerId: state?.result.sellerId,
                    id: state?.result.id,
                    title: state?.result.title,
                    price: state?.result.price,
                    rating: state?.result.rating,
                    ratings: state?.result.ratings,
                    seller: state?.result.seller,
                    image1_url: state?.result.image1_url,
                    image2_url: state?.result.image2_url,
                    image3_url: state?.result.image3_url,
                    image4_url: state?.result.image4_url,
                    image5_url: state?.result.image5_url,
                    description1: state?.result.description1,
                    description2: state?.result.description2,
                    description3: state?.result.description3,
                    description4: state?.result.description4,
                    description5: state?.result.description5,
                  },
                });
              }}
              style={{ textDecoration: "none" }}
            >
              <Product
                sellerId={state?.result.sellerId}
                id={state?.result.id}
                title={state?.result.title}
                price={state?.result.price}
                rating={state?.result.rating}
                ratings={state?.result.ratings}
                seller={state?.result.seller}
                image1_url={state?.result.image1_url}
                image2_url={state?.result.image2_url}
                image3_url={state?.result.image3_url}
                image4_url={state?.result.image4_url}
                image5_url={state?.result.image5_url}
                description1={state?.result.description1}
                description2={state?.result.description2}
                description3={state?.result.description3}
                description4={state?.result.description4}
                description5={state?.result.description5}
              />
            </Link>
          </Grid>
        )}
        <Grid item xs={12} className="home__row"></Grid>
        <div id="productClickedId" ref={mySectionRef}>
          {productId && (
            <Grid
              item
              ml={{ md: 8, lg: 60 }}
              mr={{ md: 8, lg: 60 }}
              justifyContent="center"
            >
              <ProductDetail />
            </Grid>
          )}
        </div>
        <Grid />
        {products.map((prd, i) => {
          return (
            <Grid
              key={i + new Date()}
              item
              flex={1}
              xs={6}
              sm={6}
              md={2}
              lg={2}
              justifyContent="center"
            >
              <Link
                to={`/Home/${prd.id}`}
                onClick={() => {
                  //
                  // keep a copy on device storage for retreival in Detail page, if detail page refreshes
                  localStorage.setItem(
                    "dls-pedroDetail",
                    JSON.stringify({ ...prd })
                  );
                  //
                  // dispatch to reducer
                  dispatch({
                    type: "SELECT_ITEM",
                    item: {
                      sellerId: prd.sellerId,
                      id: prd.id,
                      title: prd.title,
                      price: prd.price,
                      rating: prd.rating,
                      ratings: prd.ratings,
                      seller: prd.seller,
                      image1_url: prd.image1_url,
                      image2_url: prd.image2_url,
                      image3_url: prd.image3_url,
                      image4_url: prd.image4_url,
                      image5_url: prd.image5_url,
                      description1: prd.description1,
                      description2: prd.description2,
                      description3: prd.description3,
                      description4: prd.description4,
                      description5: prd.description5,
                    },
                  });
                }}
                style={{ textDecoration: "none" }}
              >
                <Product
                  sellerId={prd.sellerId}
                  id={prd.id}
                  title={prd.title}
                  price={prd.price}
                  rating={prd.rating}
                  ratings={prd.ratings}
                  image1_url={prd.image1_url}
                  seller={prd.seller}
                  description1={prd.description1}
                />
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
export default Home;
